<div class="sidebar__header">
    <div class="sidebar__logo">
        <div class="sidebar__logo-icon"></div>
        <div class="sidebar__logo-text"></div>
    </div>
    <button
        class="sidebar__expand-button"
        (click)="toggleMenu.emit()"
    >
        <eb-icon
            class="sidebar__expand-button-icon"
            [icon]="expanded ? 'ui/nav/close_menu' : 'ui/nav/open_menu'"
            width="32"
        />
    </button>
</div>

@if (!user() && expanded) {
    <div class="d-flex w-100 justify-content-center">
        @if (hasRegistration()) {
            <button
                class="sidebar__top-button"
                (click)="signup.emit()"
            >
                {{ 'common.sidebar.signup' | transloco }}
            </button>
        }
    </div>
}

@if (user() && expanded && hasFreeTrial() && plan && plan?.isFreemium && !user()?.freeTrialUsed) {
    <div class="d-flex">
        <button
            class="sidebar__top-button"
            (click)="planClick(plan)"
            >{{ 'common.sidebar.test_premium' | transloco }}</button
        >
    </div>
}

@if (userItem) {
    <div class="sidebar__user">
        <eb-sidebar-menu-item
            #buttonRefUser
            data-testid="sidebar-user-menu"
            tabindex="0"
            role="button"
            [description]="userItem.description"
            [disabled]="userItem.disabled"
            [expanded]="expanded"
            [icon]="userItem.icon"
            [iconPosition]="'top'"
            [label]="userItem.label"
            [selected]="userItem.selected"
            (click)="clickItem(userItem, buttonRefUser)"
            (keyup.enter)="clickItem(userItem, buttonRefUser)"
        />
    </div>
}

@if (user() && expanded && plan) {
    <div class="d-flex align-self-center">
        <eb-label
            tabindex="0"
            role="button"
            class="sidebar__tag"
            (click)="hasFreeTrial() && planClick(plan)"
            (keyup.enter)="hasFreeTrial() && planClick(plan)"
            size="sm"
            >{{ plan.name }}</eb-label
        >
    </div>
}

<div class="sidebar__middle">
    @for (item of mainItems(); track trackByItem($index, item)) {
        <eb-sidebar-menu-item
            ebAuthorisation
            #mainItemRef
            [attr.data-testid]="'sidebar-menu-' + item.key"
            [attr.data-key]="item.key"
            [activeChildKey]="activeChildKey"
            [authorisationPermissions]="item.permissions"
            [authorisationResume]="item.resumeFeature"
            [children]="item.children ?? []"
            [customClass]="['unauthorised__main-menu']"
            [description]="item.description"
            [disabled]="item.disabled"
            [expanded]="expanded"
            [icon]="item.icon"
            [isNew]="item.isNew"
            [label]="item.label"
            [notifications]="item.notifications"
            [selected]="item.selected"
            [submenuOpen]="expandedSubmenuKey === item.key"
            (childClick)="onChildClick($event)"
            (protectedClick)="clickItem(item, mainItemRef)"
        />
    }
</div>

<div #buttonRef></div>

<div class="sidebar__bottom">
    @for (item of otherItems(); track trackByItem($index, item)) {
        <eb-sidebar-menu-item
            ebTracking
            #buttonRef
            tabindex="0"
            role="button"
            [description]="item.description"
            [disabled]="item.disabled"
            [expanded]="expanded"
            [icon]="item.icon"
            [isNew]="item.isNew"
            [label]="item.label"
            [notifications]="item.notifications"
            [selected]="item.selected"
            [trackingAction]="item?.tracking ?? null"
            (click)="clickItem(item, buttonRef)"
            (keyup.enter)="clickItem(item, buttonRef)"
        />
    }
</div>

<ng-template
    #subMenuTemplate
    let-items="items"
>
    <eb-dropdown-panel-alt
        [radius]="true"
        [withBorder]="false"
        [withNotch]="false"
    >
        <eb-dropdown-panel-body>
            <div class="m-0 dropdown dropdown--bg-black">
                @for (subMenuItem of currentSubMenuItems; track trackByItem($index, subMenuItem)) {
                    <div
                        [attr.data-testid]="'sidebar-submenu-' + subMenuItem.key"
                        tabindex="0"
                        role="button"
                        class="dropdown__item dropdown__item--border-black"
                        (click)="clickSubItem(subMenuItem)"
                        (keyup.enter)="clickSubItem(subMenuItem)"
                        onKeyDown
                    >
                        {{ subMenuItem.label }}
                    </div>
                }
            </div>
        </eb-dropdown-panel-body>
    </eb-dropdown-panel-alt>
</ng-template>
